export const DRAFT_PACKAGE_FORM_SET_VALUES = 'DRAFT_PACKAGE_FORM_SET_VALUES';
export const DRAFT_PACKAGE_FORM_RESET_VALUES = 'DRAFT_PACKAGE_FORM_RESET_VALUES';